module.exports = __webpack_public_path__ + "img/feature-7.61a4063e.png";